import { gql } from "@apollo/client";

export const getB2bCampaigns = gql`
  query GetB2bCampaigns(
    $offset: Int!
    $limit: Int!
    $validFrom: String
    $validTo: String
  ) {
    getB2bCampaigns(
      offset: $offset
      limit: $limit
      validFrom: $validFrom
      validTo: $validTo
    ) {
      id
      campaignNo
      campaignName
      validFrom
      validTo
      storeGroupId
    }
  }
`;
